// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AddressForm from '../../../../../elements/AddressForm/AddressForm';
import Checkbox from '../../../../../elements/Checkbox/Checkbox';
import classNames from 'classnames/bind';

import style from '../CheckoutStep.scss';

import type { Option } from '../../../../../elements/Select/Select';
import type { Admin, Country } from '../../../../../entities';

type Props = {
  +handleBillingAddressUseSameAddress: (e: Event) => void;
  +handleChangeAdmin1: (option: Option) => void;
  +handleChangeAdmin2: (option: Option) => void;
  +handleChangeAdmin3: (option: Option) => void;
  +handleChange: (e: SyntheticInputEvent<HTMLInputElement>) => void;
  +handleChangePhone: (e: Event) => void;
  +handleFocus: (e: Event) => void;
  +handlePhoneInit: (cleave: any) => void;
  +country: Country;
  +admin1: {
    value: string;
    label?: string;
    errors?: string[];
  };
  +admin1Items: Admin[];
  +isLoadingAdmin1?: boolean;
  +admin2: {
    value: string;
    label?: string;
    errors?: string[];
  };
  +admin2Items: Admin[];
  +isLoadingAdmin2?: boolean;
  +admin3: {
    value: string;
    label?: string;
    errors?: string[];
  };
  +admin3Items: Admin[];
  +isLoadingAdmin3?: boolean;
  +address1: {
    value: string;
    errors?: string[];
  };
  +address2: {
    value: string;
    errors?: string[];
  };
  +firstName: {
    value: string;
    errors?: string[];
  };
  +idNumber: {
    value: string;
    errors?: string[];
  };
  +lastName: {
    value: string;
    errors?: string[];
  };
  +name: {
    value: string;
    errors?: string[];
  };
  +phone: {
    value: string;
    errors?: string[];
  };
  +zipCode: {
    value: string;
    errors?: string[];
  };
  +useSameAddress: {
    value: boolean;
  };
  +hideSameAddressOption: boolean;
};

export class BillingAddress extends Component<Props> {
  render() {
    const {
      handleChangeAdmin1, handleChangeAdmin2, handleChangeAdmin3, handleChange, handleChangePhone, handleFocus, handlePhoneInit,
      country, admin1, admin1Items, isLoadingAdmin1, admin2, admin2Items, isLoadingAdmin2, admin3, admin3Items, isLoadingAdmin3,
      address1, address2, firstName, idNumber, lastName, name, phone, zipCode, useSameAddress,
      handleBillingAddressUseSameAddress, hideSameAddressOption,
    } = this.props;
    return (
      <Fragment>
        <FormattedMessage id="newOrder.checkout.billing.title">{
          txt => <h2 className={style.title}>4. {txt}</h2>
        }</FormattedMessage>
        {!hideSameAddressOption &&
        <FormattedMessage id="newOrder.checkout.billing.sameAddress">{
          txt =>
            <Checkbox handleChange={handleBillingAddressUseSameAddress}
                      name="useSameAddress"
                      value="useSameAddress"
                      isChecked={useSameAddress.value}
                      className={classNames(style.sameAddressOption, !useSameAddress.value ? style.useSameAddress : '')}>
              {txt}
            </Checkbox>
        }</FormattedMessage>}
        {!useSameAddress.value &&
        <AddressForm type="billing"
                     handleChangeAdmin1={handleChangeAdmin1}
                     handleChangeAdmin2={handleChangeAdmin2}
                     handleChangeAdmin3={handleChangeAdmin3}
                     handleChange={handleChange}
                     handleChangePhone={handleChangePhone}
                     handleFocus={handleFocus}
                     country={{ value: country }}
                     admin1={admin1}
                     admin2={admin2}
                     admin3={admin3}
                     admin1Items={admin1Items}
                     admin2Items={admin2Items}
                     admin3Items={admin3Items}
                     isLoadingAdmin1={isLoadingAdmin1}
                     isLoadingAdmin2={isLoadingAdmin2}
                     isLoadingAdmin3={isLoadingAdmin3}
                     address1={address1}
                     address2={address2}
                     firstName={firstName}
                     idNumber={idNumber}
                     lastName={lastName}
                     name={name}
                     phone={phone}
                     zipCode={zipCode}
                     handlePhoneInit={handlePhoneInit}/>}
      </Fragment>
    )
  }
}


BillingAddress.propTypes = {
  handleBillingAddressUseSameAddress: PropTypes.func.isRequired,
  handleChangeAdmin1: PropTypes.func.isRequired,
  handleChangeAdmin2: PropTypes.func.isRequired,
  handleChangeAdmin3: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChangePhone: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired,
  handlePhoneInit: PropTypes.func.isRequired,
  country: PropTypes.string.isRequired,
  admin1: PropTypes.object.isRequired,
  admin1Items: PropTypes.array,
  isLoadingAdmin1: PropTypes.bool,
  admin2: PropTypes.object.isRequired,
  admin2Items: PropTypes.array,
  isLoadingAdmin2: PropTypes.bool,
  admin3: PropTypes.object.isRequired,
  admin3Items: PropTypes.array,
  isLoadingAdmin3: PropTypes.bool,
  address1: PropTypes.object.isRequired,
  address2: PropTypes.object.isRequired,
  firstName: PropTypes.object.isRequired,
  idNumber: PropTypes.object.isRequired,
  lastName: PropTypes.object.isRequired,
  name: PropTypes.object.isRequired,
  phone: PropTypes.object.isRequired,
  zipCode: PropTypes.object.isRequired,
  useSameAddress: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/components/BillingAddress/BillingAddress.jsx